function findNativeCSSRuleIndex(cssRules, nativeRule) {
    for(let i = 0; i < cssRules.length; i++){
        if (cssRules[i] === nativeRule) {
            return i;
        }
    }
    return -1;
}

export { findNativeCSSRuleIndex as default };
